<template>
    <v-container class="fill-height" style="display: block;" fluid :class="{'widget-mode': $props.widgetMode, 'updates-stopped': alarmUpdatesStopped}">
    <template v-if="$store.state.batchConfig.webapp_alarms">

        <div class="updates-stopped-text mb-2" v-if="alarmUpdatesStopped">
            <v-icon class="mr-3" color="#FB8C00">mdi-alert</v-icon>
            <span>ALARM UPDATES TURNED OFF!</span>
            <v-icon class="ml-3" color="#FB8C00">mdi-alert</v-icon>
            <v-btn color="#c42111" class="ml-3" height="25" @click="toggleAlarmUpdates">Enable</v-btn>
        </div>

        <div v-if="showGrid && !$props.widgetMode && !alarmUpdatesStopped">
            <h3 style="display: inline-block" v-text="(alarmsMode == 'current' ? `Current Alarms${optionsText}` : 'Historical Alarms')"></h3>
            <v-menu :close-on-content-click="true">
                <template #activator="{ on: onMenu }">
                    
                    <span v-on="onMenu" style="margin-left: -35px; position: absolute;" />
                    <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                        <template #activator="{ on: onTooltip }">
                            <v-btn class="ml-3 mb-2 grid-button" title="Alarms Menu" fab dark x-small color="#c42111" v-on="{ ...onMenu, ...onTooltip }">
                                <v-icon dark>mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <span>Alarms Menu</span>
                    </v-tooltip>

                </template>
                <v-list>
                    <v-list-item @click="alarmDrawerToggle">
                        <v-list-item-title><v-icon :size="'16'">mdi-dock-right</v-icon> Action Drawer</v-list-item-title>
                    </v-list-item>
                    <v-list-group :value="false" no-action color="#ffffff" @click.stop="">
                        <template v-slot:activator>
                            <v-list-item-title><v-icon :size="'16'">mdi-format-letter-case</v-icon> Density</v-list-item-title>
                        </template>

                        <v-list-item @click="toggleGridSmallMode">
                            <v-icon class="density-check" :size="'16'" v-if="!gridSmallMode">mdi-check-bold</v-icon>
                            <v-list-item-title>Comfortable</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="toggleGridSmallMode">
                            <v-icon class="density-check" :size="'16'" v-if="gridSmallMode">mdi-check-bold</v-icon>
                            <v-list-item-title>Compact</v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item @click="refreshAlarmList('user request')" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-refresh</v-icon> Refresh List</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="viewOptionClick('recentlyCleared')" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-timetable</v-icon>{{` ${viewRecentlyCleared ? 'Hide' : 'Show'} Recently Cleared`}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="viewOptionClick('unmodified')" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-square-edit-outline</v-icon>{{` Show ${viewUnmodified ? 'Processed' : 'Unmodified'}`}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showViewsFavsDetails = true">
                        <v-list-item-title><v-icon :size="'16'">mdi-content-save</v-icon>{{` Save Alarms View${$store.state.user.device_type ? ` (${$store.state.user.device_type})` : ''}`}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showViewManagementClick" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-monitor-multiple</v-icon> Alarms View Management</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="clearView">
                        <v-list-item-title><v-icon :size="'16'">mdi-layers-remove</v-icon> Clear View</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="manualEntryClick" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-bell-plus</v-icon> Manual Entry</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportToExcelFile">
                        <v-list-item-title><v-icon :size="'16'">mdi-file-excel</v-icon> Excel Data File</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportToCsvFile">
                        <v-list-item-title><v-icon :size="'16'">mdi-file</v-icon> CSV File</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showHistoricalParams = true">
                        <v-list-item-title><v-icon :size="'16'">mdi-history</v-icon> Historical Alarms</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="currentAlarmsClick" v-if="!current">
                        <v-list-item-title><v-icon :size="'16'">mdi-bell-ring</v-icon> Current Alarms</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-3 mb-2 grid-button" title="Fullscreen" fab dark x-small color="#c42111" @click="toggleFullscreen" v-on="on">
                        <v-icon dark>mdi-fullscreen</v-icon>
                    </v-btn>
                </template>
                <span>Fullscreen</span>
            </v-tooltip>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-3 mb-2 grid-button" title="Fullscreen" fab dark x-small color="#c42111" @click="toggleAlarmUpdates" v-on="on">
                        <v-icon dark>mdi-bell-off</v-icon>
                    </v-btn>
                </template>
                <span>Turn off alarm updates</span>
            </v-tooltip>

            <div class="view-select-container">
                <v-select class="view-select" outlined label="Alarm View" color="#c42111" :items="alarmViewsFavs" v-model="selectedAlarmView" return-object item-text="view_name" @change="applyGridConfig">
                    <template v-slot:item="{item}">
                        <span v-text="item.view_name" />
                        <span class="view-select-default-text" v-text="'DEFAULT'" v-if="item.default" />
                    </template>
                </v-select>

                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-3 view-button" fab dark x-small color="#c42111" @click="showViewsFavsDetails = true" title="Save Alarm View" v-on="on">
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                    </template>
                    <span>Save Alarm View</span>
                </v-tooltip>

                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2 view-button" fab dark x-small color="#c42111" @click="showViewManagementClick" title="Alarm View Management" v-on="on">
                            <v-icon>mdi-monitor-multiple</v-icon>
                        </v-btn>
                    </template>
                    <span>Alarm View Management</span>
                </v-tooltip>

                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2 view-button" fab dark x-small color="#c42111" @click="clearView" title="Clear View" v-on="on">
                            <v-icon>mdi-layers-remove</v-icon>
                        </v-btn>
                    </template>
                    <span>Clear View</span>
                </v-tooltip>
            </div>
        </div>

        <div id="ag-grid-alarms-container-fullscreen" :class="{'widget-mode': $props.widgetMode}">
            <v-overlay id="ag-grid-alarms-container-fullscreen-overlay" v-if="($store.getters.fullscreenIsActive && ($store.getters.dialogIsActive || showAlarmDetails || showAlarmRemark))" />
            <div id="ag-grid-alarms-container" :class="{drawer: alarmDrawer}">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    :groupHeaders="true"
                    :rowSelection="'multiple'"
                    :rowDeselection="true"
                    @selectionChanged="onRowSelectionChanged"
                    @row-double-clicked="details"
                    :detailCellRendererParams="detailCellRendererParams"
                    :isRowMaster="isRowMaster"
                    :masterDetail="true"
                    :suppressDragLeaveHidesColumns="true"
                    :suppressMakeColumnVisibleAfterUnGroup="true"
                    :rowGroupPanelShow="'always'"
                    :groupSelectsChildren="true"
                    :groupSelectsFiltered="true"
                    :getRowHeight="getRowHeight"
                    :sendToClipboard="sendToClipboard">
                </ag-grid-vue>
            </div>

            <div id="alarms-drawer" :class="{active: alarmDrawer && showGrid}">
                <action-drawer :selectedRows="selectedRows" :show="alarmDrawer && showGrid" :current="current" :issueTemplates="issueTemplates"
                    @details="details" 
                    @timeline="timeline" 
                    @acknowledge="acknowledgeClick" 
                    @unacknowledge="unacknowledgeClick" 
                    @clear="clearClick" 
                    @unclear="unclearClick" 
                    @serviceaffecting="markAsServiceAffectingClick" 
                    @unserviceaffecting="unMarkAsServiceAffectingClick" 
                    @remark="showAlarmRemark = true"
                    @escalate="escalateToClick"
                    @createAlarmModification="createAlarmModification"
                    @createPagingRule="createPagingRule"
                    @createIssue="createIssue"
                    @siteBook="siteBook"
                    @editSite="editSite">
                </action-drawer>
            </div>

        </div>

        <span class="refresh-text" v-text="current ? alarmRefreshText : `Historical Alarm: ${alarmsList.length} results`" />
        <span class="row-count-text" v-if="showGrid && gridApi">
            <span> {{ `${gridApi.getDisplayedRowCount()} rows, ` }}</span>
            <span>{{ `${selectedRows.length} selected`}}</span>
        </span>

        <v-dialog v-model="showAlarmDetails" max-width="80%" width="1800px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAlarmDetails = false : null}">
            <alarm-details v-if="showAlarmDetails" :alarm="selectedRows[0]" :alarmGridResources="alarmGridResources" @close="showAlarmDetails = false"></alarm-details>
        </v-dialog>

        <v-dialog v-model="showAlarmTimeline" max-width="80%" width="1600px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAlarmTimeline = false : null}">
            <alarm-timeline v-if="showAlarmTimeline" :alarms="selectedRows" @close="showAlarmTimeline = false"></alarm-timeline>
        </v-dialog>

        <v-dialog v-model="showAlarmRemark" max-width="80%" width="550px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAlarmRemark = false : null}">
            <alarm-remark v-if="showAlarmRemark" @cancel="showAlarmRemark = false" @ok="addRemark"></alarm-remark>
        </v-dialog>

        <v-dialog v-model="showViewManagement" max-width="80%" width="1400px" persistent v-if="showViewManagement" @keydown="(k) => {k.key == 'Escape' ? showViewManagement = false : null}">
            <view-management :viewType="'alarm'" :views="alarmViews" :currentViewGridConfig="currentViewGridConfig" @close="showViewManagement = false" @open="(view) => {this.selectedAlarmView = view; applyGridConfig();}" @delete="handleViewDelete"></view-management>
        </v-dialog>

        <v-dialog v-model="showViewsFavsDetails" max-width="80%" width="550px" persistent v-if="showViewsFavsDetails" @keydown="(k) => {k.key == 'Escape' ? showViewsFavsDetails = false : null}">
            <views-favs-details :viewType="'alarm'" :selectedView="selectedAlarmView" :views="alarmViews" @cancel="showViewsFavsDetails = false" @new="saveNewView" @overwrite="overwriteView"></views-favs-details>
        </v-dialog>

        <v-dialog v-model="showManualEntry" max-width="80%" width="550px" persistent @keydown="(k) => {k.key == 'Escape' ? showManualEntry = false : null}">
            <alarm-manual-entry v-if="showManualEntry" @cancel="showManualEntry = false" @create="manualEntry"></alarm-manual-entry>
        </v-dialog>

        <v-dialog v-model="showSiteCachedMetrics" max-width="80%" width="1500" persistent @keydown="(k) => {k.key == 'Escape' ? showSiteCachedMetrics = false : null}">
            <site-cached-metrics :alarmSites="alarmSites" v-if="showSiteCachedMetrics" @close="showSiteCachedMetrics = false"></site-cached-metrics>
        </v-dialog>
        <v-dialog v-model="showHistoricalParams" max-width="80%" width="650px" persistent @keydown="(k) => {k.key == 'Escape' ? showHistoricalParams = false : null}">
            <historical-params v-if="showHistoricalParams" :historicalAlarmsParams="historicalAlarmsParams" :historicalParamsResources="historicalParamsResources" @setResources="(p) => {this.historicalParamsResources = p}" @cancel="showHistoricalParams = false" @run="runHistoricalAlarms"></historical-params>
        </v-dialog>

    </template>


    <template v-if="!$store.state.batchConfig.webapp_alarms">
        <div class="no-license-text">
            <p>
                You do not have a license for Telsasoft Alarms. </br>
                Please visit <a style="color:#c42111;" href="https://telsasoft.com/tecalert/" target="_blank">here</a> for more information.
            </p>
        </div>
    </template>

    </v-container>
</template>

<script>
import _ from 'lodash';
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import { CustomAggFuncs, rowColorFuncs, alarmPipeFilterParams, alarmDateFilterParams } from "@/components/Alarms/AlarmFuncs";
import AlarmDetails from "@/components/Alarms/AlarmDetails";
import AlarmTimeline from "@/components/Alarms/AlarmTimeline";
import AlarmManualEntry from "@/components/Alarms/AlarmManualEntry";
import SiteCachedMetrics from "@/components/Alarms/SiteCachedMetrics";
import ViewManagement from "@/components/ViewManagement";
import ViewsFavsDetails from "@/components/ViewsFavsDetails";
import AlarmRemark from "@/components/Alarms/AlarmRemark";
import ActionDrawer from "@/components/Alarms/ActionDrawer";
import HistoricalParams from "@/components/Alarms/HistoricalParams";
import moment from 'moment';
export default {
    name: 'Alarms',
    props: ['widgetMode', 'widgetCommand'],
    components: {
        'ag-grid-vue': AgGridVue,
        AlarmDetails,
        AlarmTimeline,
        AlarmRemark,
        ActionDrawer,
        AlarmManualEntry,
        SiteCachedMetrics,
        ViewManagement,
        ViewsFavsDetails,
        HistoricalParams
    },
    data: () => ({
        alarmDrawer: false,
        alarmsMode: 'current',
        viewRecentlyCleared: false,
        viewUnmodified: false,
        alarmRefreshTime: null,
        alarmRefreshText: '',
        alarmsList: [],
        showGrid: false,
        gridOptions: {},
        gridApi: null,
        detailCellRendererParams: {},
        isRowMaster: null,
        gridSmallMode: false,
        selectedRows: [],
        historicalAlarmsParams: null,
        showAlarmDetails: false,
        showAlarmTimeline: false,
        showAlarmRemark: false,
        showManualEntry: false,
        showSiteCachedMetrics: false,
        alarmSites: [],
        technicianOptions: [],
        localeOptions: [],
        siteTagOptions: [],
        issueTemplates: [],
        issueTemplatesSubmenu: [],

        alarmViews: [],
        selectedAlarmView: null,
        showViewsFavsDetails: false,
        showViewManagement: false,
        currentViewGridConfig: null,
        defaultColumnState: null,
        
        showHistoricalParams: false,
        historicalParamsResources: null,
        pollCheck: null,
        alarmSubscriptionUnsubscribeFunc: null,
        alarmUpdatesStopped: false
    }),

    computed: {
        current: function() {
            return (this.alarmsMode == 'current');
        },

        alarmTrayFilter: function() {
            return this.$store.state.alarmTrayFilter;
        },

        optionsText: function() {
            let text = '';
            if(this.viewRecentlyCleared || this.viewUnmodified) {
                if(this.viewRecentlyCleared && this.viewUnmodified) {
                    text = ' (Showing recently cleared and unmodified)';
                }
                else {
                    text = ` (Showing ${this.viewRecentlyCleared ? 'recently cleared' : ''} ${this.viewUnmodified ? 'unmodified' : ''})`;
                }
            }
            return text;
        },

        gridRowPadding: function() {
            return (this.gridSmallMode ? '0px' : '8px');
        },
        gridRowIconSize: function() {
            return (this.gridSmallMode ? '16px' : '26px');
        },

        alarmViewsFavs: function() {
            return this.alarmViews.length ? this.alarmViews.filter(v => {return v.fav}) : [];
        },

        alarmGridResources: function() {
            return {
                technicianOptions: this.technicianOptions,
                localeOptions: this.localeOptions,
                siteTagOptions: this.siteTagOptions,
                issueTemplates: this.issueTemplates
            };
        }
    },

    methods: {
        getSetFilterResources: function() {
            let route = `${TELSA.apiHost}alarms/historicalresources`;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.technicianOptions = result.technician_list;
                this.localeOptions = result.locale_list;
                this.siteTagOptions = result.site_group_list.map(s => s.site_group_name);

                // Build the context menu sublist for issue templates
                this.issueTemplatesSubmenu.push({
                    name: "NO TEMPLATE",
                    action: () => this.createIssue(null)
                });
                this.issueTemplates = result.issue_templates_list;
                for(let template of this.issueTemplates) {
                    this.issueTemplatesSubmenu.push({
                        name: template.name,
                        action: () => this.createIssue(template)
                    });
                }
            });
        },
        getAlarmViews: function() {
            let route = `${TELSA.apiHost}views/list/alarm`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                console.log('ALARM VIEWS: ', results);
                this.alarmViews = results;
                this.selectedAlarmView = this.selectedAlarmView || this.alarmViewsFavs.find(v => {return v.default}) || (this.alarmViewsFavs.length ? this.alarmViewsFavs[0] : null);
            });
        },
        overwriteView: function() {
            TELSA.loading(true);
            this.showViewsFavsDetails = false;
            this.selectedAlarmView.view_grid_config = {
                gridData: this.gridOptions.columnApi.getColumnState(),
                filterData: this.gridOptions.api.getFilterModel(),
                sortData: this.gridOptions.api.getSortModel(),
                alarmDrawer: this.alarmDrawer,
                alarmDrawerWidthPct: (parseFloat((document.getElementById('alarms-drawer').offsetWidth / document.getElementById('telsasoft-application').offsetWidth).toFixed(2))),
                gridSmallMode: this.gridSmallMode
            };
            let route = `${TELSA.apiHost}views/edit`;
            return this.$http.post(route, {args: {view: this.selectedAlarmView, old_view_name: this.selectedAlarmView.view_name}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },
        saveNewView: function(newView) {
            TELSA.loading(true);
            this.showViewsFavsDetails = false;

            // If they set this new view as the new default, then we have to unset the old one.
            if(newView.viewDefault) {
                for(let view of this.alarmViews) {
                    view.default = false;
                }    
            }
            this.selectedAlarmView = {
                user_id: this.$store.state.user.user_id,
                view_type: 'alarm',
                view_name: newView.viewName,
                view_device_type: this.$store.state.user.device_type,
                view_public: newView.viewPublic,
                view_grid_config: {
                    gridData: this.gridOptions.columnApi.getColumnState(),
                    filterData: this.gridOptions.api.getFilterModel(),
                    sortData: this.gridOptions.api.getSortModel(),
                    alarmDrawer: this.alarmDrawer,
                    gridSmallMode: this.gridSmallMode
                },
                fav: true,
                default: newView.viewDefault
            };
            this.alarmViews.push(this.selectedAlarmView);
            this.alarmViews.sort((a,b) => (a.view_name.toLowerCase() > b.view_name.toLowerCase()) ? 1 : ((b.view_name.toLowerCase() > a.view_name.toLowerCase()) ? -1 : 0));
            let route = `${TELSA.apiHost}views/add`;
            return this.$http.post(route, {args: {view: this.selectedAlarmView}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
            });
        },
        saveViewsFavs: function() {
            let alarmViewsFavs = [];
            for(let view of this.alarmViews) {
                if(view.fav) {
                    alarmViewsFavs.push({
                        user_id: view.user_id,
                        view_name: view.view_name,
                        default: view.default
                    });
                }
            }

            let route = `${TELSA.apiHost}views/favs`;
            return this.$http.post(route, {args: {view_type: 'alarm', views_favs: alarmViewsFavs}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },
        handleViewDelete: function(view) {
            if(view == this.selectedAlarmView) {
                this.selectedAlarmView = null;
            }
        },


        getInitialAlarmsList: function() {
            //let route = (TELSA.apiHost + "alarms/list");
            TELSA.loading(true);
            this.alarmsList = this.$store.state.alarmsList;
            this.buildAgGrid();
            this.updateAlarmRefreshTime('initial load');
        },

        refreshAlarmList: function(refreshMethod) {
            if(this.viewRecentlyCleared || this.viewUnmodified) {
                let route = (TELSA.apiHost + "alarms/list/options");
                TELSA.loading(true);
                return this.$http.post(route, {args: {cleared: this.viewRecentlyCleared, unmodified: this.viewUnmodified}}).then(response => {
                    let result = response.body;
                    this.alarmsList = result;
                    this.gridApi.setRowData(this.alarmsList);
                    this.updateAlarmRefreshTime(refreshMethod);
                    TELSA.loading(false);
                });
            }
            else {
                // let route = (TELSA.apiHost + "alarms/list");
                // TELSA.loading(true);
                // return this.$http.get(route).then(response => {
                //     let result = response.body;
                //     this.alarmsList = result;
                //     this.gridApi.setRowData(this.alarmsList);
                //     this.updateAlarmRefreshTime(refreshMethod);
                //     TELSA.loading(false);
                // });

                if(refreshMethod == 'user request') {
                    TELSA.loading(true);   
                }
                this.$store.dispatch('getCurrentAlarms').then(r => {
                    this.updateAlarmRefreshTime(refreshMethod);
                    TELSA.loading(false);
                });
            }
        },

        updateAlarmRefreshTime: function(refreshMethod) {
            // Don't reset the refresher timer if its a delta. Because the backend alarms socket is, at best, "not very reliable", we need
            // to still rely on a full refresh to maintain an accurate alarms list. sigh....
            // But we still want to display the latest delta time.
            let timestamp = TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('HH:mm:ss');
            if(refreshMethod != 'delta') {
                this.alarmRefreshTime = TELSA.moment.tz(this.$store.state.batchConfig.timezone);
            }
            this.alarmRefreshText = `Alarms refreshed at ${timestamp} (${refreshMethod})`;
        },

        viewOptionClick: function(viewOption) {
            if(viewOption == 'recentlyCleared') {
                this.viewRecentlyCleared = !this.viewRecentlyCleared;
            }
            else if(viewOption == 'unmodified') {
                this.viewUnmodified = !this.viewUnmodified
            }
            this.refreshAlarmList('parameter change');
        },

        buildAgGrid: function() {
            this.showGrid = false;
            let self = this;
            this.gridOptions = {};
            this.gridOptions.rowData = this.alarmsList;
            this.gridOptions.deltaRowDataMode = true;
            this.gridOptions.getRowNodeId = function(data) {
                return data.alarm_id;
            }

            // Filter out child alarms(i.e. alarms that have a "parent")
            this.gridOptions.isExternalFilterPresent = () => {return true;};
            this.gridOptions.doesExternalFilterPass = (params) => {return !params.data.parents;};
            this.gridOptions.columnDefs = this.createColumnDefs();
            this.detailCellRendererParams = this.createSubColumnDefs();
            this.gridOptions.keepDetailRows = true;
            this.gridOptions.keepDetailRowsCount = 2;
            this.gridOptions.autoGroupColumnDef = {
                headerName: "Group",
                cellRendererParams: {
                    checkbox: true
                }
            };
            this.isRowMaster = function(data) {
                return (data.alarm_repeats ? true : false);
            };
            this.getRowHeight = function(params) {
                if(params.node && params.node.detail) {
                    const offset = 80;
                    return ((params.data.alarm_repeats * 28) + offset);
                }
                return (self.gridSmallMode ? 24 : 40);
            };
            this.gridOptions.suppressCellSelection = true;

            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
                self.defaultColumnState = self.gridOptions.columnApi.getColumnState();

                self.gridOptions.api.addAggFunc('summary', CustomAggFuncs.severitySummary);
                self.gridOptions.api.addAggFunc('highest', CustomAggFuncs.maxSeverity);
                self.gridOptions.api.addAggFunc('lowest', CustomAggFuncs.minSeverity);
                self.gridOptions.api.addAggFunc('newest', CustomAggFuncs.newestDate);
                self.gridOptions.api.addAggFunc('oldest', CustomAggFuncs.oldestDate);
                self.gridOptions.api.addAggFunc('ackCount', CustomAggFuncs.yesCount);
                self.gridOptions.api.addAggFunc('clearCount', CustomAggFuncs.yesCount);
                self.gridOptions.api.addAggFunc('saCount', CustomAggFuncs.yesCount);
                self.gridApi = self.gridOptions.api;
                self.applyGridConfig();
            }

            this.gridOptions.onCellContextMenu = function(params) {
                if(params.node && params.node.group) {
                    self.gridApi.hidePopupMenu();
                    return;
                }
                params.node.setSelected(true, (self.selectedRows.length <= 1));
            }
            this.gridOptions.getContextMenuItems = function(params) {
                return [
                    {
                        name: 'Details',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.details();
                        }
                    },
                    {
                        name: 'Timeline',
                        disabled: (self.selectedRows.length > 12),
                        action: function() {
                            self.timeline();
                        }
                    },
                    'separator',
                    {
                        name: 'Acknowledge',
                        action: function() {
                            self.acknowledgeClick();
                        }
                    },
                    {
                        name: 'Clear',
                        action: function() {
                            self.clearClick();
                        }
                    },
                    {
                        name: 'Mark as Service Affecting',
                        action: function() {
                            self.markAsServiceAffectingClick();
                        }
                    },
                    'separator',
                    {
                        name: 'Add Remark',
                        action: function() {
                            self.showAlarmRemark = true;
                        }
                    },
                    'separator',
                    {
                        name: 'Un-Acknowledge',
                        action: function() {
                            self.unacknowledgeClick();
                        }
                    },
                    {
                        name: 'Un-Clear',
                        action: function() {
                            self.unclearClick();
                        }
                    },
                    {
                        name: 'Un-Mark as Service Affecting',
                        action: function() {
                            self.unMarkAsServiceAffectingClick();
                        }
                    },
                    'separator',
                    {
                        name: 'Escalate To',
                        subMenu: [
                            {   
                                name: 'Critical',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/critical')),
                                action: function() {
                                    self.escalateToClick('critical');
                                }
                            },
                            {   
                                name: 'Major',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || (self.selectedRows[0].alarm_severity == 'MAJOR') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/major')),
                                action: function() {
                                    self.escalateToClick('major');
                                }
                            },
                            {   
                                name: 'Minor',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || (self.selectedRows[0].alarm_severity == 'MAJOR') || (self.selectedRows[0].alarm_severity == 'MINOR') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/minor')),
                                action: function() {
                                    self.escalateToClick('minor');
                                }
                            }
                        ]
                    },
                    'separator',
                    {
                        name: 'Create Alarm Modification',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.createAlarmModification();
                        }
                    },
                    {
                        name: 'Create Paging Rule',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.createPagingRule();
                        }
                    },
                    'separator',
                    {
                        name: 'Create Issue',
                        subMenu: self.issueTemplatesSubmenu,
                        disabled: (self.selectedRows.length > 1)
                    },
                    {
                        name: 'Site Book',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.siteBook();
                        }
                    },
                    {
                        name: 'Edit Site',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.editSite();
                        }
                    },
                    {
                        name: 'Site Cached Metrics',
                        action: function() {
                            self.viewCachedMetrics();
                        }
                    },
                    'separator',
                    {
                        name: 'Copy',
                        disabled: (self.selectedRows.length != 1),
                        subMenu: [
                            {   
                                name: 'Office',
                                disabled: false,
                                action: function() {
                                    let officeText = `${self.selectedRows[0].alarm_office}`;
                                    navigator.clipboard.writeText(officeText);
                                }
                            },
                            {   
                                name: 'Location',
                                disabled: false,
                                action: function() {
                                    let officeText = `${self.selectedRows[0].alarm_location}`;
                                    navigator.clipboard.writeText(officeText);
                                }
                            },
                            {   
                                name: self.parseOutIpAddress() ? `IP Address (${self.parseOutIpAddress()})` : 'IP Address',
                                disabled: !self.parseOutIpAddress(),
                                action: function() {
                                    navigator.clipboard.writeText(self.parseOutIpAddress());
                                }
                            }
                        ]
                    },
                    'separator',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'alarmsList');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }

            // Set the row colors based on alarm severity
            this.gridOptions.getRowStyle = function(params) {
                if(!params.data) {
                    // This means that the row is a grouped row. Lets examine the leaf children and find the highest priority to color it.
                    return rowColorFuncs.getGroupRowColor(params.node.allLeafChildren, self.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
                }
                return rowColorFuncs.getRowColor(params, self.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
            }

            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: 'When', 
                    field: 'alarm_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    cellRenderer: "agGroupCellRenderer",
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Local Time', 
                    field: 'alarm_local_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Office', 
                    field: 'alarm_office', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Location', 
                    field: 'alarm_location', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true
                },
                {
                    headerName: 'Facility', 
                    field: 'alarm_facility_type', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true
                },
                { 
                    headerName: 'Severity', 
                    field: 'alarm_severity', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL']
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableValue: true,
                    allowedAggFuncs: ["summary", "highest", "lowest"],
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Description', 
                    field: 'alarm_description', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Rep',
                    field: 'alarm_repeats',
                    width: 150, 
                    filter: 'agNumberColumnFilter', 
                    filterParams: {
                        suppressAndOrCondition: true,
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_repeats ? params.data.alarm_repeats : '');
                    },
                    allowedAggFuncs: ['min', 'max'],
                    enableValue: true,
                },
                { 
                    headerName: 'Ack',
                    field: 'alarm_acked',
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['Yes', null]
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_ack_time.length ? "Yes" : "");
                    },
                    allowedAggFuncs: ['ackCount'],
                    enableValue: true,
                },
                { 
                    headerName: 'Clear', 
                    field: 'alarm_cleared',
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['Yes', null]
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_clear_time.length ? "Yes" : "");
                    },
                    allowedAggFuncs: ['clearCount'],
                    enableValue: true,
                },
                { 
                    headerName: 'Technician', 
                    field: 'user_username', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.technicianOptions.concat([null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Page Time', 
                    field: 'page_time',
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let page_time = "";
                        if(params.data.paged_times && params.data.paged_times.length) {
                            return params.data.paged_times.length > 1 ? '[multiple]' : params.data.paged_times[0];
                        }
                        return page_time;
                    },
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Ack Time', 
                    field: 'alarm_ack_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Clear Time', 
                    field: 'alarm_clear_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Paged To', 
                    field: 'paged_to', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let page_to = "";
                        if(params.data.paged_users && params.data.paged_users.length) {
                            return params.data.paged_users.length > 1 ? '[multiple]' : params.data.paged_users[0].split('paged')[1];
                        }
                        return page_to;
                    }
                },
                { 
                    headerName: 'Acked By',
                    field: 'alarm_acked_by', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        if(params.data.alarm_ack_time.length) {
                            return (params.data.alarm_ack_user ? (params.data.alarm_ack_user == "SYSTEM" ? "[SYSTEM]" : params.data.alarm_ack_user) : "");
                        }
                        return "";
                    },
                },
                { 
                    headerName: 'Cleared By', 
                    field: 'alarm_cleared_by',
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        if(params.data.alarm_clear_time.length) {
                            return (params.data.alarm_clear_user ? (params.data.alarm_clear_user == "SYSTEM" ? "[SYSTEM]" : params.data.alarm_clear_user) : "[DEVICE]");
                        }
                        return "";
                    },
                },
                { 
                    headerName: 'Locale', 
                    field: 'site_locale', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.localeOptions.concat([null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Site Tags', 
                    field: 'site_tags', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.siteTagOptions.concat([null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Site Name', 
                    field: 'site_name', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Service Affecting (SA)', 
                    field: 'alarm_service_affecting',
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['Yes', null]
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_service_affecting == 't' ? "Yes" : "");
                    },
                    allowedAggFuncs: ['saCount'],
                    enableValue: true,
                },
                { 
                    headerName: 'Datafill', 
                    field: 'datafill',
                    width: 90, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
                        let siteDatafillA = !!nodeA.data.site_id;
                        let geoDatafillA = (nodeA.data.geo_datafill == "t");
                        let siteDatafillB = !!nodeB.data.site_id;
                        let geoDatafillB = (nodeB.data.geo_datafill == "t");

                        if(siteDatafillA && geoDatafillA && !(siteDatafillB && geoDatafillB)) return -1;
                        if((siteDatafillA || geoDatafillA) && (!siteDatafillB && !geoDatafillB)) return -1;
                        if(!(siteDatafillA && geoDatafillA) && siteDatafillB && geoDatafillB) return 1;
                        if((!siteDatafillA && !geoDatafillA) && (siteDatafillB || geoDatafillB)) return 1;
                        if((siteDatafillA == siteDatafillB) && (geoDatafillA == geoDatafillB)) return 0;
                    },
                    cellRenderer: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let eElement = document.createElement('div');
                        eElement.innerHTML = `<span class="mdi ${params.data.site_id ? 'mdi-radioactive': 'mdi-radioactive-off'} alarm-datafill-icon" title="${params.data.site_id ? '': 'No site defined'}" style="cursor: default; font-size: ${self.gridRowIconSize};" />
                            <span class="mdi ${params.data.geo_datafill == 't' ? 'mdi-earth': 'mdi-earth-off'} alarm-datafill-icon" title="${params.data.geo_datafill == 't' ? '': 'Missing geo-data'}" style="cursor: default; font-size: ${self.gridRowIconSize};" />`
                        return eElement;
                    }.bind(this)
                },
            ];
            return columnDefs;
        },

        createSubColumnDefs: function() {
            return {
                detailGridOptions: {
                    columnDefs: [
                        { field: "alarm_time" },
                        { field: "alarm_office" },
                        { field: "alarm_location" },
                        { field: "alarm_severity" },
                        { field: "alarm_description" }
                    ],
                    onFirstDataRendered(params) {
                        params.api.sizeColumnsToFit();
                    }
                },
                onGridReady: params => {
                    params.api.setDomLayout("autoHeight");
                },
                getDetailRowData: params => {
                    // Make alarm just have this one needed field because we dont want to send up the whole thing which could be very large(history, desc, repeats, etc....)
                    let alarm = {alarm_id: params.data.alarm_id, alarm_id_linkage_back: params.data.alarm_id_linkage_back};
                    let route = `${TELSA.apiHost}alarms/repeatlist`
                    this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                        let results = response.body;
                        params.data.repeat_list = results;
                        params.successCallback(params.data.repeat_list);
                    });
                }
            };
        },

        applyGridConfig: function() {
            console.log('APPLY GRID!');
            // Are they coming from the alarm tray?
            if(this.$store.state.alarmTrayFilter) {
                if(this.alarmTrayFilter.toUpperCase() == 'TELSASOFT') {
                    this.gridOptions.api.setFilterModel({alarm_office: {filterType: 'text', type: 'contains', filter: this.alarmTrayFilter.toUpperCase()}});
                }
                else {
                    this.gridOptions.api.setFilterModel({alarm_severity: {filterType: 'set', values: [this.alarmTrayFilter.toUpperCase()]}});
                }
                this.$store.commit('setAlarmTrayFilter', null);
                TELSA.loading(false);
                return;
            }

            // If there is no alarm view then we're done.
            if(this.selectedAlarmView) {
                this.gridOptions.columnApi.setColumnState(this.selectedAlarmView.view_grid_config.gridData);
                this.gridOptions.api.setFilterModel(this.selectedAlarmView.view_grid_config.filterData);
                this.gridOptions.api.setSortModel(this.selectedAlarmView.view_grid_config.sortData);
                this.alarmDrawer = this.selectedAlarmView.view_grid_config.alarmDrawer ? this.selectedAlarmView.view_grid_config.alarmDrawer : false;

                let alarmDrawerWidthPct = this.selectedAlarmView.view_grid_config.alarmDrawerWidthPct;
                let alarmDrawerWidth = alarmDrawerWidthPct ? parseFloat((alarmDrawerWidthPct * document.getElementById('telsasoft-application').offsetWidth).toFixed(2)) : 256;
                document.getElementById('alarms-drawer').style.width = `${alarmDrawerWidth}px`;
                if(this.alarmDrawer) {
                    document.getElementById('ag-grid-alarms-container').style.width = `calc(100% - ${alarmDrawerWidth}px)`;
                }


                this.gridSmallMode = this.selectedAlarmView.view_grid_config.gridSmallMode ? this.selectedAlarmView.view_grid_config.gridSmallMode : false;
            }
            // we need to trigger the UI to change to compact/comfortable mode.
            this.gridApi.resetRowHeights();
            this.gridApi.redrawRows();
            TELSA.loading(false);
        },

        exportToExcelFile: function() {
            let params = {
                fileName: `${this.current ? 'Current' : 'Historical'}Alarms_${TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('MMM_DD_YYYY')}`,
                sheetName: 'data'
            }
            this.gridOptions.api.exportDataAsExcel(params);
        },
        exportToCsvFile: function() {
            let params = {
                fileName: `${this.current ? 'Current' : 'Historical'}Alarms_${TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('MMM_DD_YYYY')}`,
                sheetName: 'data'
            }
            this.gridOptions.api.exportDataAsCsv(params);
        },

        alarmDrawerToggle: function() {
            this.alarmDrawer = !this.alarmDrawer;
            if(this.alarmDrawer) {
                let drawerWidth = document.getElementById('alarms-drawer').offsetWidth;
                document.getElementById('ag-grid-alarms-container').style.width = `calc(100% - ${drawerWidth}px)`;
            }
            else {
                document.getElementById('ag-grid-alarms-container').style.width = '100%';
            }
        },

        onRowSelectionChanged: function() {
            let selectedRows = this.gridOptions.api.getSelectedRows();
            this.selectedRows = selectedRows;
            if(this.selectedRows.length === 1) {
                let alarm = this.selectedRows[0];
                let route = (TELSA.apiHost + "alarms/historyremarks");
                this.$http.post(route, {args: {alarmIds: [alarm.alarm_id]}}).then(response => {
                    let historyremarks = response.data[0];
                    alarm.alarm_history = historyremarks.history;
                    alarm.alarm_remarks = historyremarks.remarks;
                    this.selectedRows.splice(0,0); // trigger the action drawer props to re-run computeds
                });
            }
            else if(this.selectedRows.length > 1) {
                let alarmIds = this.selectedRows.map(a => a.alarm_id);
                let route = (TELSA.apiHost + "alarms/historyremarks");
                this.$http.post(route, {args: {alarmIds: alarmIds}}).then(response => {
                    let historyremarks = response.data;
                    for(let [index, alarm] of this.selectedRows.entries()) {
                        alarm.alarm_history = historyremarks[index].history;
                        alarm.alarm_remarks = historyremarks[index].remarks;
                    }
                    this.selectedRows.splice(0,0); // trigger the action drawer props to re-run computeds
                });
            }
        },

        details: function() {
            let route = (TELSA.apiHost + "alarms/details");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmId: this.selectedRows[0].alarm_id}}).then(response => {
                let result = response.body;
                this.selectedRows[0].details = result;
                this.showAlarmDetails = true;
                TELSA.loading(false);
            });
        },

        timeline: function() {
            this.showAlarmTimeline = true;
        },

        acknowledgeClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Acknowledge',
                message: `Are you sure you want to acknowledge ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.acknowledge()
            });
        },
        acknowledge: function() {
            let route = (TELSA.apiHost + "alarms/acknowledge");
            let alarmIDs = this.selectedRows.map(r => r.alarm_id);
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmIDs: alarmIDs}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>acknowledge</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        clearClick: function() {
            let children = [];
            this.selectedRows.forEach(r => {children = r.children ? children.concat(r.children) : []});
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Clear',
                message: `Are you sure you want to clear ${this.selectedRows.length + children.length > 1 ? `these ${this.selectedRows.length + children.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.clear(children)
            });
        },
        clear: function(children) {
            let route = (TELSA.apiHost + "alarms/clear");
            TELSA.loading(true);
            let alarms_id_list = this.selectedRows.map(r => r.alarm_id);
            if(children) {
                alarms_id_list = alarms_id_list.concat(children);
            }
            return this.$http.post(route, {args: {alarms: alarms_id_list}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>clear</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        markAsServiceAffectingClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Mark',
                message: `Are you sure you want to mark ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.markAsServiceAffecting()
            });
        },
        markAsServiceAffecting: function() {
            let route = (TELSA.apiHost + "alarms/serviceaffecting");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>mark service affecting</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        addRemark: function(remarkText) {
            this.showAlarmRemark = false;
            let route = (TELSA.apiHost + "alarms/remark");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows, remark: remarkText}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>add remarks</b> to the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unacknowledgeClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Acknowledge',
                message: `Are you sure you want to un-acknowledge ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unacknowledge()
            });
        },
        unacknowledge: function() {
            let route = (TELSA.apiHost + "alarms/unacknowledge");
            let alarmIDs = this.selectedRows.map(r => r.alarm_id);
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmIDs: alarmIDs}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unacknowledge</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unclearClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Clear',
                message: `Are you sure you want to un-clear ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unclear()
            });
        },
        unclear: function() {
            let route = (TELSA.apiHost + "alarms/unclear");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unclear</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unMarkAsServiceAffectingClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Mark',
                message: `Are you sure you want to un-mark ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unMarkAsServiceAffecting()
            });
        },
        unMarkAsServiceAffecting: function() {
            let route = (TELSA.apiHost + "alarms/unserviceaffecting");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unmark service affecting</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        manualEntryClick: function() {
            if(!TELSA.checkPermission(this.$store.state.user, 'alarm/manual-entry')) {
                this.$store.commit('insufficientPermissions', {message: `You do not have permission to manually create alarms.`});
            }
            else {
                this.showManualEntry = true;
            }
        },
        manualEntry: function(alarm) {
            let route = (TELSA.apiHost + "alarms/manualentry");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                this.showManualEntry = false;
                TELSA.loading(false);
            });
        },

        escalateToClick: function(level) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Escalate',
                message: `Are you sure you want to escalate ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'} to ${level}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.escalateTo(level)
            });
        },
        escalateTo: function(level) {
            let route = (TELSA.apiHost + "alarms/escalate");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: this.selectedRows[0], escalate: level}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>escalate</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        createAlarmModification: function() {
            this.$store.commit('setAlarmModificationShortcut', this.selectedRows[0]);
            this.$router.push('alarmmodifications');
        },
        createPagingRule: function() {
            this.$store.commit('setPagingRuleShortcut', this.selectedRows[0]);
            this.$router.push('pagingrules');
        },

        createIssue: function(template) {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return; // if the alarm got cleared while they had it selected then we should stop.
            }
            let route = (TELSA.apiHost + "issues/alarmdetails");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                alarm.alarm_details = result.alarm_details;
                alarm.alarm_site_id = result.alarm_site_id;
                this.$store.commit('setCreateIssueFromAlarmShortcut', {alarm: alarm, issueTemplate: template});
                this.$router.push('issues');
            });
        },

        siteBook: function() {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return;
            }
            let route = (TELSA.apiHost + "sites/getsiteid");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                let siteId = result;
                route = (TELSA.apiHost + `sites/site/${siteId}`);
                return this.$http.get(route).then(response => {
                    result = response.body;
                    let site = result.site;
                    TELSA.loading(false);
                    if(site.tree_id == -1) {
                        this.$store.commit('showConfirmModal', {
                            title: 'Site Book Help',
                            message: `The selected site has not been assigned to a tree. You can assign a tree from the 'sites' page`,
                            type: '',
                            hideCancel: true,
                            confirmAction: () => {}
                        });
                    }
                    else {
                        this.$store.commit('setEditSiteBookFromAlarmShortcut', site);
                        this.$router.push('sitebook');
                    }
                });
            });
        },

        editSite: function() {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return;
            }
            let route = (TELSA.apiHost + "sites/getsiteid");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                alarm.alarm_site_id = result;
                this.$store.commit('setEditSiteFromAlarmShortcut', alarm);
                TELSA.loading(false);
                this.$router.push('sites');
            });
        },

        viewCachedMetrics: function() {
            let alarmSites = [];
            for(let alarm of this.selectedRows) {
                let alarmSite = alarmSites.find(as => as.siteId == alarm.site_id);
                if(alarmSite) {
                    alarmSite.alarms.push(alarm);
                }
                else {
                    alarmSites.push({
                        siteId: alarm.site_id, 
                        siteName: alarm.site_name, 
                        siteOffice: alarm.alarm_office, 
                        siteLocation: alarm.alarm_location, 
                        alarms: [alarm],
                        siteThresholdMetrics: []
                    });
                }
            }
            let emptyIndex = alarmSites.findIndex(as => !as.siteId);
            if(emptyIndex != -1) {
                alarmSites.push(alarmSites.splice(emptyIndex, 1)[0]); // move alarms for unmatched site to end of list
            }
            this.alarmSites = alarmSites;
            this.showSiteCachedMetrics = true;
        },

        runHistoricalAlarms: function(params) {
            TELSA.loading(true);
            params.startDateTime = moment(params.startDateTime).format('YYYY-MM-DD HH:mm:ss');
            params.endDateTime = moment(params.endDateTime).format('YYYY-MM-DD HH:mm:ss');
            this.showHistoricalParams = false;
            this.historicalAlarmsParams = params;
            let route = (TELSA.apiHost + "alarms/historical");
            return this.$http.post(route, {args: {params: params}}).then(response => {
                let result = response.body;
                if(result.file_name) {
                    let historicalAlarmsFile = result.zip_file_name;
                    let historicalAlarmsFilePrettyName = result.file_name;

                    let dlink = document.createElement('a');
                    dlink.setAttribute("id", "report-download-file-link-hidden");
                    let url = new URL(`${TELSA.staticHost}${historicalAlarmsFile}?prettyname=${historicalAlarmsFilePrettyName}`);
                    dlink.href = url;
                    dlink.click();
                    dlink.remove();

                    this.$store.commit('showConfirmModal', {
                        title: 'Large Results',
                        message: `The historical alarm results are too large to display in the application(${TELSA.readableFileSize(result.result_size)}). A csv file has been downloaded instead.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                    TELSA.loading(false);
                }
                else {
                    this.alarmsMode = 'historical';
                    this.alarmsList = result;
                    this.gridApi.setRowData(this.alarmsList);
                    this.applyGridConfig();
                }
            });
        },

        currentAlarmsClick: function() {
            this.alarmsMode = 'current';
            this.refreshAlarmList('user request');
            this.applyGridConfig();
        },



        handleUpdateAlarms: function(updatedAlarms) {
            for(let updatedAlarm of updatedAlarms) {
                for(let [i, alarm] of this.alarmsList.entries()) {
                    if(updatedAlarm.alarm_id == alarm.alarm_id) {
                        this.alarmsList[i] = updatedAlarm;
                        break;
                    }
                }
            }

            // If we're not showing recently cleared alarms then we need to remove the cleared ones.
            if(!this.viewRecentlyCleared) {
                this.alarmsList = this.alarmsList.filter(alarm => {
                    return !alarm.alarm_clear_time;
                });
            }

            this.gridApi.setRowData(this.alarmsList);
            this.updateAlarmRefreshTime('delta');
        },

        handleNewAlarms: function(newAlarms) {
            let actualNewAlarms = [];
            let actuallyNew;

            // Check thru the list of newAlarms to see if any are duplicates(same "alarm_key_str") of each other.
            // We turn the list of alarms into a list of groups of alarms by alarm_key_str. Then for each group we take 
            // the alarm that has the highest repeat count(most recent alarm of that group) and add it to the newAlarms list.
            let newAlarmsFiltered = [];
            let alarmKeyStrGroups = _.groupBy(newAlarms, a => {
                return a.alarm_key_str;
            });
            for(let agKey in alarmKeyStrGroups) {
                let agList = alarmKeyStrGroups[agKey];
                newAlarmsFiltered.push(agList.reduce((prev, current) => {return (prev.alarm_repeats > current.alarm_repeats ? prev : current)}));
            }
            newAlarms = newAlarmsFiltered;


            for(let newAlarm of newAlarms) {
                actuallyNew = true;
                for(let [i, alarm] of this.alarmsList.entries()) {
                    // Including check for alarm_id as a failsafe to avoid ever having 2 or more grid rows with the same id(alarm_id). If that were to happen its real bad.
                    if((newAlarm.alarm_id == alarm.alarm_id) || (newAlarm.alarm_key_str == alarm.alarm_key_str)) {
                            // Found a match so reset the old one to new one. This takes care of "Rep"    
                            this.alarmsList[i] = newAlarm;
                            actuallyNew = false;
                            break;
                    }
                }
                if(actuallyNew) {
                    actualNewAlarms.push(newAlarm);
                }
            }
            this.alarmsList = this.alarmsList.concat(actualNewAlarms);

            // If we're not showing recently cleared alarms then we need to remove the cleared ones.
            if(!this.viewRecentlyCleared) {
                this.alarmsList = this.alarmsList.filter(alarm => {
                    return !alarm.alarm_clear_time;
                });
            }

            this.gridApi.setRowData(this.alarmsList);
            this.updateAlarmRefreshTime('delta');
        },

        setupAutoPolling: function() {
            let self = this;
            const fiveMin = 300000;
            this.pollCheck = setInterval(function() {
                if(((TELSA.moment.tz(self.$store.state.batchConfig.timezone) - self.alarmRefreshTime) > fiveMin) && self.current) {
                    self.refreshAlarmList('polled');
                    self.alarmRefreshTime = TELSA.moment.tz(self.$store.state.batchConfig.timezone);
                }
            }, 5000); // 5 Seconds
        },


        toggleFullscreen: function() {
            try {
                document.getElementById('ag-grid-alarms-container-fullscreen').requestFullscreen();
            }
            catch(error) {
                // Must be using safari
                document.getElementById('ag-grid-alarms-container-fullscreen').webkitRequestFullscreen();
            }
        },

        toggleGridSmallMode: function() {
            this.gridSmallMode = !this.gridSmallMode;
            this.gridApi.resetRowHeights();
            this.gridApi.redrawRows();
        },

        sendToClipboard: function(params) {
            if(!this.selectedRows.length) {
                return;
            }
            let clipboardText = '';
            for(let [idx, row] of this.selectedRows.entries()) {
                clipboardText += `Alarm Details:\n`;
                clipboardText += `\tDescription:  ${row.alarm_description}\n`;
                clipboardText += `\tSite Name:    ${row.site_name}\n`;
                clipboardText += `\tLocation:     ${row.alarm_location}\n`;
                clipboardText += `\tOffice:       ${row.alarm_office}\n`;
                clipboardText += `\tSeverity:     ${row.alarm_severity}\n`;
                clipboardText += `\tRepeats:      ${row.alarm_repeats}\n`;
                clipboardText += `\tTime:         ${row.alarm_time}\n`;
                clipboardText += `\tAck Time:     ${row.alarm_ack_time}\n`;
                clipboardText += `\tAck User:     ${row.alarm_ack_user}\n`;
                clipboardText += `\tClear Time:   ${row.alarm_clear_time}\n`;
                clipboardText += `\tClear User:   ${row.alarm_clear_user}\n`;
                clipboardText += `\tLocale:       ${row.site_locale}\n`;
                clipboardText += `\tTechnician:   ${row.user_username}\n`;
                clipboardText += `Remarks:\n`;
                clipboardText += row.alarm_remarks.map(x => {return `\t[${x.username} at ${x.alarm_action_timestamp}] ${x.alarm_action_details}`}).join('\n');
                clipboardText += '\n';
                clipboardText += `History:\n`;
                clipboardText += row.alarm_history.map(x => {return `\t[${x.username} at ${x.alarm_action_timestamp}] ${x.alarm_action_details}`}).join('\n');

                if(idx != (this.selectedRows.length - 1)) {
                    clipboardText += "\n------------------------------------------\n\n";
                }
            }

            navigator.clipboard.writeText(clipboardText);
        },

        showViewManagementClick: function() {
            let obj = {
                gridData: this.gridOptions.columnApi.getColumnState(),
                filterData: this.gridOptions.api.getFilterModel(),
                sortData: this.gridOptions.api.getSortModel(),
                alarmDrawer: this.alarmDrawer,
                gridSmallMode: this.gridSmallMode
            }
            this.currentViewGridConfig = obj;
            this.showViewManagement = true;
        },

        clearView: function() {
            this.gridOptions.columnApi.setColumnState(this.defaultColumnState);
            this.gridOptions.api.setFilterModel(null);
            this.gridOptions.api.setSortModel(null);
            this.selectedAlarmView = null;
        },
        
        createAlarmSubscriptions: function() {
            this.alarmSubscriptionUnsubscribeFunc = this.$store.subscribe((mutation, state) => {
                // If user is looking at historical alarms or if the grid hasnt loaded yet then don't do anything
                if(!this.current || this.viewRecentlyCleared || this.viewUnmodified || !this.gridApi || this.alarmUpdatesStopped) {
                    if(!this.current){console.log('UPDATE BUT NOT VIEWING CURRENT.');}
                    if(this.viewRecentlyCleared){console.log('UPDATE BUT VIEWING CLEARED.');}
                    if(this.viewUnmodified){console.log('UPDATE BUT VIEWING UNMODIFIED.');}
                    if(!this.gridApi){console.log('UPDATE BUT NO GRID.');}
                    if(this.alarmUpdatesStopped){console.log('UPDATE BUT UPDATES TURNED OFF.');}
                    return;
                }
                if(mutation.type === 'SOCKET_ALARMS_NEW' || mutation.type === 'SOCKET_ALARMS_UPDATE') {
                    let selectedRowHash = (this.selectedRows.length && this.selectedRows.length === 1) ? TELSA.hash(this.selectedRows[0]) : null;
                    this.alarmsList = state.alarmsList;
                    this.gridApi.setRowData(this.alarmsList);
                    this.gridApi.redrawRows();
                    this.updateAlarmRefreshTime('delta');
                    // if they have just 1 alarm selected then go get updated history
                    try {
                        if(selectedRowHash && selectedRowHash != TELSA.hash(this.gridOptions.api.getSelectedRows()[0])) {
                            this.onRowSelectionChanged();
                        }
                    } catch(e) {}
                }
                else if(mutation.type === 'setAlarmsList') {
                    this.alarmsList = state.alarmsList;
                    this.gridApi.setRowData(this.alarmsList);
                    this.gridApi.redrawRows();
                    this.updateAlarmRefreshTime('polled');
                }
            }, {prepend: false});
        },

        toggleAlarmUpdates: function() {
            if(this.alarmUpdatesStopped) {
                this.refreshAlarmList('user request');
                this.alarmUpdatesStopped = false;
            }
            else {
                this.alarmUpdatesStopped = true;
            }
        },

        parseOutIpAddress: function() {
            let self = this;
            if(!self.selectedRows[0]) {
                return "";
            }
            let alarmFullText = self.selectedRows[0].alarm_full_text;
            let ipRegex = new RegExp(".*IP Address: (?<common_value>.+)\n\n", "gm");
            let match = alarmFullText.matchAll(ipRegex).next();
            if(match && match.value && match.value.groups && match.value.groups.common_value) {
                match = match.value.groups.common_value;
            }
            else {
                match = "";
            }
            return match;
        }
    },


    // ONLY USED FOR WHEN THEYRE LOOKING AT RECENTLY CLEARED ALARMS
    sockets: {
        ALARMS_UPDATE: function(updatedAlarms) {
            // Don't do anything if theyre looking at historical, unmodified, or if grid isnt loaded yet.
            if(!this.current || !this.viewRecentlyCleared || this.viewUnmodified || !this.gridApi) {
                //console.log('UPDATE BUT NOT VIEWING RECENTLY CLEARED.')
                return;
            }
            this.handleUpdateAlarms(updatedAlarms);
        },
        ALARMS_NEW: function(newAlarms) {
            // Don't do anything if theyre looking at historical, unmodified, or if grid isnt loaded yet.
            if(!this.current || !this.viewRecentlyCleared || this.viewUnmodified || !this.gridApi) {
                //console.log('NEW BUT NOT VIEWING RECENTLY CLEARED.')
                return;
            }
            this.handleNewAlarms(newAlarms);
        },
    },

    mounted() {
        // If they don't have a license for alarms then dont start anything.
        if(!this.$store.state.batchConfig.webapp_alarms) {
            return;
        }

        this.alarmRefreshTime = TELSA.moment.tz(this.$store.state.batchConfig.timezone);
        let promises = [];
        promises.push(this.getSetFilterResources());
        promises.push(this.getAlarmViews());
        Promise.all(promises).then(res => {
            this.getInitialAlarmsList();
            this.setupAutoPolling();
            this.createAlarmSubscriptions();
        });
    },

    destroyed() {
        // If they don't have a license for alarms then theres nothing to clean up.
        if(!this.$store.state.batchConfig.webapp_alarms) {
            return;
        }

        this.alarmSubscriptionUnsubscribeFunc();
        clearInterval(this.pollCheck);
        this.$store.commit('setAlarmTrayFilter', null);
    },

    created() {
    },

    watch: {
        alarmTrayFilter: {
            handler(newVal, oldVal) {
                if(newVal) {
                    this.applyGridConfig();
                }
            },
        },

        widgetCommand: {
            handler(newVal, oldVal) {
                console.log('WIDGET COMMAND: ', newVal);
                if(newVal) {
                    if(newVal.type == 'clearView') {
                        this.clearView();
                    }
                    else if(newVal.type == 'setView') {
                        this.selectedAlarmView = newVal.value;
                        console.log('widget set view command: ', newVal.value);
                        if(this.showGrid) {
                            this.applyGridConfig();
                        }
                    }
                    else if(newVal.type == 'setDensity') {
                        if(this.gridSmallMode != (newVal.value == 'Compact')) {
                            this.toggleGridSmallMode();
                        }
                    }
                }
            },
        }
    },

  
};
</script>

<style scoped>

    .widget-mode {
        padding: 0px !important;
    }

    .updates-stopped {
        animation: updatesStoppedBlink 1s infinite;
    }
    @keyframes updatesStoppedBlink{
        0%{background-color: #303030;}
        49%{background-color: #303030;}
        100%{background-color: #ffffff;}
    }
    .updates-stopped-text {
        text-align: center;
    }
    .updates-stopped-text span {
        font-size: 20px;
        vertical-align: sub;
        font-weight: bold;
        animation: alertBlink 1s infinite;
    }

    .view-select-container {
        position: relative;
        display: inline-block;
        /* width: 400px; */
        margin-left: calc(50% - (450px / 1));
        text-align: center;
        height: 40px;
    }
    .view-select {
        width: 250px;
        display: inline-block;
    }
    .view-select-container .view-button {
        display: initial;
    }

    @media(max-width: 1600px) {
        .view-select-container {
            width: 400px;
            margin-left: 20px;
        }
        .view-select {
            width: 250px;
        }
    }
    @media(max-width: 900px) {
        .view-select-container {
            width: 180px;
            float: right;
        }
        .view-select {
            width: 180px;
        }
        .view-select-container .view-button {
            display: none;
        }
    }
    @media(max-width: 500px) {
        .view-select-container {
            width: 80px;
            float: right;
            display: none;
        }
        .view-select {
            width: 80px;
        }
    }

    .view-select-default-text {
        color: yellow;
        position: absolute;
        right: 20px;
        text-align: right;
        font-size: 11px;
        font-weight: bold;
    }

    .density-check {
        margin-left: -35px;
        margin-right: 18px;
    }

    #ag-grid-alarms-container-fullscreen {
        width: 100%;
        height: calc(100vh - 135px);
    }
    #ag-grid-alarms-container-fullscreen.widget-mode {
        height: 100%;
    }

    #ag-grid-alarms-container {
        width: 100%;
        max-width: 100%;
        display: block;
        height: 100%;
    }
    #ag-grid-alarms-container.drawer {
        max-width: calc(100% - 256px);
        display: inline-block;
        float: left;
    }

    #alarms-drawer {
        width: 0px;
        height: 0px;
        background-color: #ffffff;
        display: inline-block;
        float: left;
    }
    #alarms-drawer.active {
        width: 256px;
        height: 100%;
    }

    .refresh-text {
        font-size: 10pt;
        bottom: 5px;
        left: 18px;
        position: absolute;
    }

    .row-count-text {
        font-size: 10pt;
        display: block;
        width: 200px;
        font-size: 10pt;
        bottom: 5px;
        left: calc(50% - (200px / 2));
        text-align: center;
        position: absolute;
    }

</style>

<style>
    #ag-grid-alarms-container .ag-row-hover {
        /* putting in !important so it overrides the theme's styling as it hovers the row also */
        background-color: #c8e6c9 !important;
    }

    #ag-grid-alarms-container .ag-row-selected {
        background-color: #0000ff !important;
        color: #ffffff !important;
    }

    #ag-grid-alarms-container .ag-theme-balham .ag-icon.ag-icon-tree-closed {
        color: #000000;
        font-weight: bold;
        margin-top: -10px;
        font-size: 20px;
    }

    .view-select-container .v-text-field.v-text-field--outlined .v-input__control{
        min-height: 10px !important;
    }
    .view-select-container .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 10px !important;
    }
    .view-select-container .v-text-field.v-text-field--enclosed .v-input__prepend-outer, .v-text-field.v-text-field--enclosed .v-input__prepend-inner, .v-text-field.v-text-field--enclosed .v-input__append-inner, .v-text-field.v-text-field--enclosed .v-input__append-outer {
        margin-top: 7px !important;
    }
    .view-select-container .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
        padding-top: 4px !important;
        padding-bottom: 2px !important;
    }
    .view-select-container .v-text-field--outlined .v-label {
        top: 11px !important;
    }
    .view-select-container .v-text-field--outlined .v-label--active {
        top: 17px !important;
    }
</style>

